<template>
    <modal name="conformArchivemodal" classes="v-modal-sec" :min-width="200" :min-height="200" :scrollable="true"
      :reset="true" width="450px" height="auto">
      <div class="v-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">
            Reason For Delete
          </h2>
          <span @click="$modal.hide('conformArchivemodal'); selectedReason=null; internalComments='';">
            <em class="material-icons">close</em>
          </span>
        </div>
        <form data-vv-scope="eVerifyForm">
          <div class="form-container">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="form_group">
                  <label class="typo__label">Select Reason<em>*</em></label>
                  <multiselect v-model="selectedReason" :options="closeReasons" :multiple="false"
                    :hideSelected="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                    :select-label="'Search Internal Status'" placeholder="Select Reason" label="name" track-by="name"
                    :preselect-first="false" :searchable="true" name="internalStatus" data-vv-as="Select Reason"
                    v-validate="'required'" @input="">
                  </multiselect>
                </div>
                <span class="text-danger text-sm"
                  v-show="errors.has('eVerifyForm.internalStatus')">{{ errors.first("eVerifyForm.internalStatus") }}</span>
              </div>
              <div class="vx-col w-full">
                <div class="form_group">
                  <label class="form_label">Comments<em>*</em></label>
                  <ckeditor data-vv-as="Comments" v-validate="'required'" v-model="internalComments" name="internalcomments"
                    class="w-full" :editor="editor" :config="editorConfig"></ckeditor>
                  <span class="text-danger text-sm" v-show="errors.has('eVerifyForm.internalcomments')">
                    <em>*</em> Comments are required</span>
                </div>
              </div>
            </div>
  
            <div v-if="formerrors.msg">
              <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
            </div>
          </div>
        </form>
        <div class="popup-footer relative">
          <figure v-if="archiving" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
          <vs-button color="dark" class="cancel" type="filled" @click="$modal.hide('conformArchivemodal'); formerrors.msg=''">Cancel
          </vs-button>
          <vs-button :disabled="archiving" color="success" class="save" type="filled" @click="submitCase()">Submit
          </vs-button>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  import CKEditor from "@ckeditor/ckeditor5-vue2";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
  import Multiselect from "vue-multiselect-inv";
  export default {
    provide() {
      return {
          parentValidator: this.$validator,
      };
  },
    props:{
        caseNumber:null
    }, 
    components: {
    Multiselect,
    ckeditor: CKEditor.component,
    },
    data() {
      return {
        selectedReason: null, 
        closeReasons: [], 
        internalComments: "", 
        archiving: false,
        formerrors: {
          msg: "", 
        },
        editor: ClassicEditor, 
        editorConfig: {
          toolbar: ["bold", "italic", "|", "undo", "redo"],
        },
      };
    },
    methods: {
      submitCase(){

        this.$validator.validateAll("eVerifyForm").then((result) => {
            if(result){
                let path = '/i9-everify/close-case'
                let postData={
                    'caseNumber':this.caseNumber,
                    'caseCloseReason':this.checkProperty(this.selectedReason, 'code'), 
                    'caseCloseDesc': this.internalComments
                }
                this.$store.dispatch("commonAction", {"data":postData ,"path":path})
                .then(response => {
                    if(response){
                        this.showToster({message:error,isError:false});
                        this.$emit('removeCase', this.caseNumber);
                        this.$modal.hide("conformArchivemodal");
                    }    
                }).catch((error)=>{
                    this.showToster({message:error,isError:true });
                })

            }
        })
      
      },
      getCaseCloseReasons(){
        let path = '/i9-everify/get-close-reasons'
        let postData={
            'caseNumber':this.caseNumber
        }
        this.$store.dispatch("commonAction", {"data":postData ,"path":path})
        .then(response => {
            if(response){
                this.closeReasons = response
            }    
        }).catch((error)=>{
            this.showToster({message:error,isError:true });
        })
      },
    },
    mounted(){
        if(this.caseNumber){
           this.getCaseCloseReasons()
           this.$modal.show('conformArchivemodal')
        }
        
    }
  };
  </script>
  
  